import { render, staticRenderFns } from "./iHandConfig.vue?vue&type=template&id=0c8a10b6&"
import script from "./iHandConfig.vue?vue&type=script&lang=js&"
export * from "./iHandConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports